import { PageShell, Block } from "./PageShell";

const SAFETY_EMAIL = "felicia@ourheardcommunity.com";

const prohibited = [
  "Child sexual abuse material (CSAM)",
  "Content that sexually exploits or endangers minors",
  "Grooming or attempts to exploit children",
  "Solicitation involving minors",
  "Human trafficking or child exploitation",
  "Any illegal content involving children",
];

const moderationActions = [
  "Remove violating content",
  "Suspend or permanently ban accounts",
  "Escalate serious violations for further review",
  "Cooperate with law enforcement when legally required",
];

const responsibilities = [
  "Treat others respectfully.",
  "Follow the Community Guidelines.",
  "Report harmful or suspicious behavior immediately.",
  "Never post or share illegal or exploitative material.",
];

const List = ({ items }) => (
  <ul className="list-disc space-y-1.5 pl-5 marker:text-sage">
    {items.map((i) => (
      <li key={i}>{i}</li>
    ))}
  </ul>
);

export default function ChildSafety() {
  return (
    <PageShell
      title="Child Safety Standards"
      intro="Effective Date: July 2026. At HEARD, we are committed to creating a safe, respectful, and supportive community for all users. We maintain a zero-tolerance policy toward child sexual abuse and exploitation (CSAE), child sexual abuse material (CSAM), grooming, trafficking, or any content or behavior that exploits or endangers children."
    >
      <Block heading="Our Commitment">
        <p>
          HEARD exists to foster empathy, encouragement, and meaningful conversations. Protecting children and
          vulnerable individuals is one of our highest priorities.
        </p>
        <p>We strictly prohibit:</p>
        <List items={prohibited} />
        <p>Any account engaging in these activities will be permanently removed.</p>
      </Block>

      <Block heading="Reporting Harmful Content">
        <p>Users can report posts, comments, messages, or accounts that violate our Community Guidelines.</p>
        <p>Our moderation team reviews reports promptly and may:</p>
        <List items={moderationActions} />
      </Block>

      <Block heading="Moderation">
        <p>
          HEARD combines community reporting with moderation practices to identify and remove harmful content while
          maintaining a respectful environment.
        </p>
      </Block>

      <Block heading="Cooperation with Law Enforcement">
        <p>
          When legally required, HEARD cooperates with appropriate law enforcement agencies investigating child
          exploitation or other illegal activity.
        </p>
      </Block>

      <Block heading="User Responsibility">
        <p>All users are expected to:</p>
        <List items={responsibilities} />
      </Block>

      <Block heading="Additional Resources">
        <p>If you believe a child is in immediate danger, contact your local emergency services immediately.</p>
        <p>
          Users in the United States may also report online child sexual exploitation to the National Center for
          Missing &amp; Exploited Children (NCMEC){" "}
          <a
            className="text-sage-deep underline"
            href="https://report.cybertip.org/"
            target="_blank"
            rel="noreferrer noopener"
          >
            CyberTipline
          </a>
          .
        </p>
      </Block>

      <Block heading="Contact">
        <p>HEARD Safety Team</p>
        <p>
          Email:{" "}
          <a className="text-sage-deep underline" href={`mailto:${SAFETY_EMAIL}`} data-testid="child-safety-email">
            {SAFETY_EMAIL}
          </a>
        </p>
      </Block>
    </PageShell>
  );
}
